import React from 'react';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { getJobNoticeData } from './utils/noticeUtils';

const WitnessTestNotice = ({ job, pumpDetails, noticeData = null }) => {
  // Use provided notice data or generate it
  const notices = noticeData || getJobNoticeData(job, pumpDetails);
  
  // Check if witness test notice should be displayed
  if (!notices.notices.witnessTest?.hasNotice) {
    return null;
  }

  const witnessTest = notices.notices.witnessTest;

  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch {
      return dateString;
    }
  };  return (
    <Alert variant="info" className="mb-3">
      <Alert.Heading className="h6 mb-2">
        <i className="bi bi-clipboard-check me-2"></i>
        Witness Test Required
      </Alert.Heading>
      <div className="small">
        {witnessTest.testDate && (
          <div><strong>Test Date:</strong> {formatDate(witnessTest.testDate)}</div>
        )}
        {witnessTest.testCriteria && (
          <div><strong>Test Criteria:</strong> {witnessTest.testCriteria}</div>
        )}
        {witnessTest.complianceCertificateRequired && (
          <div><strong>Compliance Certificate Required:</strong> {witnessTest.complianceCertificateRequired}</div>
        )}
        {witnessTest.comments && (
          <div><strong>Comments:</strong> {witnessTest.comments}</div>
        )}
        {!witnessTest.testDate && !witnessTest.testCriteria && !witnessTest.complianceCertificateRequired && !witnessTest.comments && (
          <div className="text-muted">
            <em>Witness test is required for this job. Additional details can be configured in the Witness Test section.</em>
          </div>
        )}
      </div>
    </Alert>
  );
};

WitnessTestNotice.propTypes = {
  job: PropTypes.object.isRequired,
  pumpDetails: PropTypes.array,
  noticeData: PropTypes.object,
};

export default WitnessTestNotice;